export type Persona =
    'BUSINESS_USER' |
    'RPA_DEVELOPER' |
    'CITIZEN_DEV' |
    'RPA_COE' |
    'BUSINESS_ANALYST' |
    'SOLUTION_ARCHITECT' |
    'TPM' |
    'TESTER' |
    'OPERATIONS_MANAGER' |
    'ADMIN' |
    'DIGITAL_TRANSFORMATION_LEAD' |
    'BUSINESS_OWNER' |
    'AUTOMATION_EXPRESS_USER ' |
    'UNKNOWN';

export enum LEFT_NAV_PERSONAS {
    TESTER = 'TESTER', // Tester
    AUTOMATION_EXPRESS_USER = 'AUTOMATION_EXPRESS_USER', // Automation Express
    AUTOMATION_EXPRESS_ADMIN = 'AUTOMATION_EXPRESS_ADMIN', // Automation Express ADMIN
    BUSINESS_USER = 'BUSINESS_USER', // Business User
    BUSINESS_ANALYST = 'BUSINESS_ANALYST', // Analyst
    CITIZEN_DEV = 'CITIZEN_DEV', // Citizen Developer
    RPA_DEVELOPER = 'RPA_DEVELOPER', // RPA Developer
    ADMIN = 'ADMIN', // Admin
    UNKNOWN = 'UNKNOWN', // If none of those were matched
    INITIAL = 'INITIAL', // Initial state
}

export interface IWeightedPersona {
    persona: Persona;
    weight: number;
}

export interface IPersonaFit {
    fit: IWeightedPersona[];
    errorMessage?: string;
}

